var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-gtm-page":"quick-purchase-pricing","w-100":"","fx":"","fxCenter":""}},[_c('div',{staticClass:"wrapper",attrs:{"fx":"","fxcol":"","w-100":""}},[_c('PricingTable',_vm._b({},'PricingTable',_vm.pricingTableProps,false)),_c('ComparisonTable')],1),_c('Chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }